<template>
  <div class="row">
    <b-card
      class="col-12"
      title="Filtro de Avance Preliminar"
      sub-title="buscar por subcuenca y fecha"
    >
      <b-card-body>
        <b-form @submit.prevent="onsubmit" inline>
          <label class="sr-only" for="inlineFormInputName2">subcuenca</label>
          <b-input
            class="mb-2 mr-sm-2 mb-sm-0"
            id="inlineFormInputName2"
            placeholder="Subcuenca"
            v-model="filters.subcuenca"
          />
          <label class="sr-only" for="inlineFormInputName3">Zona</label>
          <b-input
            class="mb-2 mr-sm-2 mb-sm-0"
            id="inlineFormInputName3"
            placeholder="Zona"
            v-model="filters.zona"
          />

          <label class="sr-only" for="inlineFormInputGroupUsername2"
            >Fecha</label
          >
          <b-input-group prepend="Fecha" class="mb-2 mr-sm-2 mb-sm-0">
            <b-input
              type="date"
              id="inlineFormInputGroupUsername2"
              required
              v-model="filters.fecha"
            />
          </b-input-group>

          <b-button type="submit" variant="primary">Buscar</b-button>
        </b-form>
      </b-card-body>
    </b-card>
    <div
      class="col-12"
      style="font-size: 9px;overflow: scroll; max-height: 900px;"
    >
      <b-table
        class="custom-table"
        id = "tabladata"
        :small="true"
        :items="items"
        :bordered="true"
        hover
        thead-class="custom-h"
        :fields="fields"
      />
    </div>
    <br>
    <b-button variant="success" class="float-left" @click="excel">Excel</b-button>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Http from "../Http";
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
  name: "Verpreinforme",
  data: () => ({
    filters: {
      subcuenca: null,
      fecha: null,
      zona: null
    },
    items: [],
    fields: [
      {
        key: "user.user_name",
        label: "Supervisor"
      },
      {
        key: "subcuenca_id",
        label: "Subcuenca"
      },
      {
        key: "reporte_localidad",
        label:"Localidad"
      },
      {
        key: "preinforme_estado",
        label: "EP"
      },
      {
        key: "tramo_identifica",
        label: "ID TRamo"
      },
      {
        key: "reporte_orden",
        label: "Orden Tramo"
      },
      {
        key: "preinforme_fecha",
        label: "Fecha lavado",
        sortable: true,
        formatter: value => {
          return new Date(value).toLocaleDateString();
        }
      },
      {
        key: "preinforme_tipo",
        label: "Tipo Limpieza"
      },
      {
        key: "preinforme_longitud",
        label: "Longitud Terreno"
      },
      {
        key:"reporte_shapel",
        label:"Longitud shape",
        formatter: value=>{
          return Math.trunc(value);
        }
      },
      {
        key: "preinforme_inspeccion",
        label: "Inspeccionado",
        formatter: value=>{
          return (value===true)?"Sí":(value===false)?"No":value;
        }
      },
      {
        key:"preinforme_fechaitv",
        label:"Fecha ITV",
        sortable: true,
        formatter: value => {
          return new Date(value).toLocaleDateString();
        }
      },
      {
        key: "preinforme_estadoitv",
        label: "EP ITV"
      },
      {
        key: "preinforme_metrositv",
        label: "Longitud Inspeccion"
      },
      {
        key: "causa.causa_nombre",
        label: "Causa de no lavado"
      },
      {
        key: "preinforme_obsitv",
        label:"Observacion ITV"
      },
      {
        key: "operadoreslvd.operador_nombre",
        label: "Operador Limpieza"
      },
      {
        key: "preinforme_asistente",
        label: "Ayudante Limpieza"
      },
      {
        key: "preinforme_asistente",
        label: "Ayudante Limpieza"
      },
      {
        key:"zona.zona_nombre",
        label: "Zona"
      },
      {
        key: "preinforme_observacionlvd",
        label: "Observacion de lavado"
      },
      {
        key: "patente.patente_nombre",
        label: "Patente"
      }
    ]
  }),
  methods: {
    onsubmit() {
      let sc, fecha, zona;
      sc = this.filters.subcuenca;
      fecha = this.filters.fecha;
      zona = this.filters.zona;
      if (this.filters.subcuenca == null) {
        sc = "na";
      }
      if (this.filters.fecha == null) {
        fecha = "na";
      }
      if (this.filters.zona == null) {
        zona = "na";
      } else {
        zona = this.filters.zona.replace(" ", "_");
      }
      Http.Http()
        .get(`Preinf/${sc}/${fecha}/${zona}`)
        .then(resp => {
          console.log(resp);
          this.items = resp.data;
          if(resp.data.length>0){
            Http.Http().get(`Preinf/pendiente/${resp.data[0].subcuenca_id}`)
              .then(respu=>{
                this.items = this.items.concat(respu.data);
              }).catch(err=> console.log(err));
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    excel() {
      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.table_to_sheet(
        document.getElementById("tabladata")
      );
      XLSX.utils.book_append_sheet(wb, ws, "Resumen");
      let wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      let data = XLSX.write(wb, wopts);
      FileSaver.saveAs(
        new Blob([data], { type: "application/octet-stream" }),
        "Avance_Diario.xlsx"
      );
    }
  }
};
</script>

<style>
.custom-table {
  background-color: white;
  border: solid 1px black;
}
.custom-h {
  background-color: #0d6b42 !important;
  color: white;
}
</style>
